import { UncontrolledTooltip } from "reactstrap"
import { CanView } from "components/Common/CanView"
import { ACCESS } from "constants/accessPermissions"

const ReadyStockToggleButton = ({
  stock,
  loading = false,
  onToggle,
  size = "sm",
}) => {
  const stockId = stock && (stock.stock_id || stock.id)
  const isReadyStock = Boolean(stock && stock.vs_ready_stock)
  const tooltipId = `ready-stock-toggle-${stockId}`
  const nextLabel = isReadyStock ? "Mark Not Ready" : "Mark Ready Stock"

  if (!stockId) return null

  return (
    <CanView access={[ACCESS.STOCK.EDIT]}>
      <button
        type="button"
        className={`btn btn-${size} btn-soft-${
          isReadyStock ? "success" : "secondary"
        }`}
        id={tooltipId}
        disabled={loading}
        onClick={() => onToggle && onToggle(stock, !isReadyStock)}
      >
        <i
          className={
            loading
              ? "mdi mdi-loading mdi-spin"
              : `bx ${isReadyStock ? "bx-check-circle" : "bx-time-five"}`
          }
        />
      </button>
      <UncontrolledTooltip placement="top" target={tooltipId}>
        {nextLabel}
      </UncontrolledTooltip>
    </CanView>
  )
}

export default ReadyStockToggleButton
